
import { Route, Routes } from 'react-router-dom';
import { withAuthenticator, Button, Heading } from '@aws-amplify/ui-react';
import React, { useState, useEffect } from 'react';

import '@aws-amplify/ui-react/styles.css';

// import '@aws-amplify/ui-react/styles/reset.layer.css' // global CSS reset
// import '@aws-amplify/ui-react/styles/base.layer.css' // base styling needed for Amplify UI
// import '@aws-amplify/ui-react/styles/button.layer.css' // component specific styles



import AuthProvider from "./components/hooks/AuthProvider"

import NavBar from './layout/NavBar';
import MainGrid from './layout/MainGrid';


import ChannelList from './components/channel/ChannelList';
import Search from './components/search/Search';
import ChannelSearchDetails from './components/details/ChannelSearchDetails';
import ChannelDatabaseDetails from './components/details/ChannelDatabaseDetails';
import DependencyErrorHandling from './components/DependencyErrorHandling'

import { createContext, useContext } from 'react';


import '@aws-amplify/ui-react/styles.css';
import './App.css';

import { CurrentUserContext } from './components/context/CurrentUserContext';

import FormLogin from './components/auth/LoginButton'

import Home from './pages/Home'
import System from './pages/System'
import UserInfo from './pages/UserInfo'
import UsersAdmin from './pages/UsersAdmin'
import YoutubeVideoDetails from './pages/youtube/YoutubeVideoDetails'

function App() {
  const [user, setUser] = useState(null);


  useEffect(() => {
    document.title = "MyWebApp";
  }, []);

  return (
    <>


      <CurrentUserContext.Provider
        value={[user, setUser]}
      >
        <Routes>

          {/* <Route path="" element={<MainGrid><Home /> </MainGrid>} />

          <Route path="/userinfo" element={<MainGrid><UserInfo /> </MainGrid>} />

          <Route path="/admin/users" element={<MainGrid><UsersAdmin /> </MainGrid>} />
          <Route path="/admin/system" element={<MainGrid><System /> </MainGrid>} />


          <Route path="/youtube/videodetails" element={<MainGrid><YoutubeVideoDetails /> </MainGrid>} /> */}

    <Route path="" element={<MainGrid><YoutubeVideoDetails /> </MainGrid>} />

          <Route component={<MainGrid><YoutubeVideoDetails /> </MainGrid>} />
          {/*         
        <Route path="/mytube/search" element={ <MainGrid><DependencyErrorHandling><Search /></DependencyErrorHandling> </MainGrid>} />
        <Route path="/mytube/channels" element={ <MainGrid><ChannelList /> </MainGrid>} />

        <Route path="/mytube/youtube/channeldetails" element={ <MainGrid><ChannelSearchDetails /> </MainGrid>} />
        <Route path="/mytube/database/channeldetails" element={ <MainGrid><ChannelDatabaseDetails /> </MainGrid>} /> */}
        </Routes>

      </CurrentUserContext.Provider>

    </>

  );
}
export default App;

